import "./FAQItem.css";

import React, { useState } from "react";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { QuestionsModel } from "../../models/faqModel";

interface FAQItemProps {
  id: number;
  title: string;
  questions?: QuestionsModel[];
  activeQuestion: number | null;
  setActiveQuestion: React.Dispatch<React.SetStateAction<any>>;
  searchPhrase: string;
}

const FAQItem = ({
  id,
  title,
  questions,
  activeQuestion,
  setActiveQuestion,
  searchPhrase,
}: FAQItemProps) => {
  const [activeSubquestion, setActiveSubquestion] = useState<number | null>(
    null
  );

  return (
    <div
      className="faq-item-container"
      style={{
        display:
          searchPhrase.length === 0 ||
          (questions &&
            questions?.filter((q: QuestionsModel) =>
              q.question
                ?.toString()
                ?.toLowerCase()
                ?.trim()
                ?.includes(searchPhrase?.toLowerCase()?.trim())
            )?.length > 0)
            ? "flex"
            : "none",
      }}
    >
      <div className="faq-item-left">
        <div
          className="faq-item-heading"
          onClick={() =>
            id === activeQuestion
              ? setActiveQuestion(null)
              : setActiveQuestion(id)
          }
        >
          <p
            className="faq-item-title"
            style={{
              fontWeight:
                window.innerWidth <= 480 && id === activeQuestion
                  ? "bold"
                  : "normal",
            }}
          >
            {title}
          </p>
          {window.innerWidth > 480 ? (
            <p className="faq-item-expand-icon">
              {id === activeQuestion ? "-" : "+"}
            </p>
          ) : null}
        </div>
        {id === activeQuestion || window.innerWidth <= 480
          ? questions
              ?.filter(({ question }: QuestionsModel) =>
                question
                  .toString()
                  .toLowerCase()
                  .trim()
                  .includes(searchPhrase?.toLowerCase().trim())
              )
              .map(({ question, answer }: QuestionsModel, index: number) => (
                <div key={index} className="subquestion">
                  {window.innerWidth <= 480 ? (
                    <div className="faq-mobile-divider" />
                  ) : null}

                  <li
                    className="faq-subquestion"
                    onClick={() => {
                      if (index === activeSubquestion) {
                        setActiveSubquestion(null);
                      } else {
                        setActiveSubquestion(index);
                      }
                    }}
                    style={{
                      listStyle: window.innerWidth <= 480 ? "none" : "inherit",
                      fontSize: window.innerWidth > 480 ? 18 : 16,
                      fontWeight: window.innerWidth > 480 ? "normal" : 650,
                      opacity:
                        index === activeSubquestion
                          ? 1
                          : window.innerWidth > 480
                          ? 0.5
                          : 1,
                    }}
                  >
                    {question}
                    {window.innerWidth <= 480 && index === activeSubquestion ? (
                      <FontAwesomeIcon
                        className="faq-caret"
                        icon={faCaretUp}
                        size="3x"
                        color="#18283c"
                      />
                    ) : window.innerWidth <= 480 ? (
                      <FontAwesomeIcon
                        className="faq-caret"
                        icon={faCaretDown}
                        size="3x"
                        color="#18283c"
                      />
                    ) : null}
                  </li>
                  {activeSubquestion === index && window.innerWidth <= 480 && (
                    <div className="faq-item-right">
                      {questions![activeSubquestion].answer}
                    </div>
                  )}
                  {window.innerWidth <= 480 &&
                  index + 1 === questions.length ? (
                    <div
                      className="faq-mobile-divider"
                      style={{ marginTop: "5%" }}
                    />
                  ) : null}
                </div>
              ))
          : null}
      </div>
      {id === activeQuestion && window.innerWidth > 480 ? (
        <div className="faq-item-right">
          <p className="faq-answer-right">
            {activeSubquestion !== null
              ? questions![activeSubquestion].question
              : null}
          </p>
          {activeSubquestion !== null
            ? questions![activeSubquestion].answer
            : null}
        </div>
      ) : null}
    </div>
  );
};

export default FAQItem;
